import { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CompanySearch from "../../components/contract/CompanySearch";
import { createContract } from "../../api/contract/info";
import MobileAttachmentBox from "../../components/common/papers/MobileAttachmentBox";

const Info_new = () => {
  const [form, setForm] = useState({
    contract_type: "",
    contract_code: "",
    title: "",
    confirmer_company_name: "",
    amount: "",
    signed_date_actual: "",
    start_date_actual: "",
    end_date_actual: "",
    sign_date_expected: "",
    end_date_expected: "",
    memo: "",
    manualCompanyInput: false,
    construction_type: "본공사"
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const attachmentRef = useRef(null);

  const { id: projectId } = useParams();
  const navigate = useNavigate();
  // const construction_type = location.state?.construction_type || "본공사";

  const handleAmountChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, "");
    setForm({ ...form, amount: rawValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    try {
      setSaving(true);

      const formData = new FormData();
      formData.append("project", projectId);
      formData.append("construction_type", form.construction_type || "본공사");

      Object.keys(form).forEach((key) => {
        if (key !== "manualCompanyInput") formData.append(key, form[key]);
      });

      const res = await createContract(formData);
      const dnsId = typeof res.dns === "object" ? res.dns.id : res.dns;
      await attachmentRef.current?.save(dnsId);

      alert("계약이 등록되었습니다");
      navigate(`../info`);
    } catch (err) {
      console.error("등록 실패:", err);
      alert("등록 실패 다시 시도해주세요");
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "manualCompanyInput") {
      setForm((prev) => ({
        ...prev,
        manualCompanyInput: checked,
        confirmer_company_name: checked ? "" : prev.confirmer_company_name,
      }));
      return;
    }

    setForm({ ...form, [name]: value });
  };

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner space-y-3">
        <div className="w-full bg-white rounded-xl shadow p-4 sm:p-6">
        <h2 className="text-lg sm:text-xl font-bold mb-4">계약 정보 등록</h2>

        <div className="flex flex-col sm:flex-row justify-end gap-2 mb-4">
          <button
            type="submit"
            form="contract-form"
            disabled={saving}
            className="btn-create w-full sm:w-auto text-sm sm:text-base disabled:opacity-60"
          >
            {saving ? "등록 중..." : "등록"}
          </button>
        </div>

        <form id="contract-form" onSubmit={handleSubmit} className="space-y-6 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
          <div className="border rounded-lg min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            <div className="p-4 space-y-4 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
              {/* 계약 구분 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  계약 구분
                </label>
                <select
                  name="contract_type"
                  value={form.contract_type}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                >
                  <option value="">선택</option>
                  <option value="지명경쟁입찰">지명경쟁입찰</option>
                  <option value="제한경쟁입찰">제한경쟁입찰</option>
                  <option value="일반경쟁입찰">일반경쟁입찰</option>
                  <option value="수의계약">수의계약</option>
                  <option value="협상계약">협상계약</option>
                  <option value="최저가낙찰">최저가낙찰</option>
                  <option value="종합평가낙찰">종합평가낙찰</option>
                  <option value="턴키">턴키</option>
                  <option value="기술제안입찰">기술제안입찰</option>
                  <option value="대안입찰">대안입찰</option>
                  <option value="단가계약">단가계약</option>
                  <option value="총액계약">총액계약</option>
                </select>
              </div>

              {/* 계약 코드 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  계약 코드
                </label>
                <input
                  type="text"
                  name="contract_code"
                  value={form.contract_code}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                />
              </div>

              {/* 계약명 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  계약명
                </label>
                <input
                  type="text"
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                  placeholder="계약명을 입력하세요"
                />
              </div>

              {/* 금액 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  계약 금액
                </label>
                <input
                  type="text"
                  name="amount"
                  value={form.amount}
                  onChange={handleAmountChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                  placeholder="숫자만 입력"
                />
              </div>

              {/* 주계약업체 */}
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <label className="text-xs font-medium text-gray-600">
                    주계약업체
                  </label>
                  <div className="flex items-center gap-1 text-xs">
                    <input
                      id="manual-company"
                      type="checkbox"
                      name="manualCompanyInput"
                      checked={form.manualCompanyInput}
                      onChange={handleChange}
                      className="w-3 h-3"
                    />
                    <label
                      htmlFor="manual-company"
                      className="text-[11px] text-gray-700"
                    >
                      직접입력
                    </label>
                  </div>
                </div>

                {form.manualCompanyInput ? (
                  <input
                    type="text"
                    name="confirmer_company_name"
                    value={form.confirmer_company_name}
                    onChange={handleChange}
                    placeholder="업체명을 직접 입력하세요"
                    className="w-full border rounded-md px-2 py-1 text-sm"
                  />
                ) : (
                  <div className="flex gap-2 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                    <input
                      type="text"
                      readOnly
                      value={form.confirmer_company_name}
                      placeholder="선택된 업체 없음"
                      className="flex-1 min-w-0 border rounded-md px-2 py-1 bg-gray-100 text-sm"
                      style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                    />
                    <button
                      type="button"
                      onClick={() => setModalOpen(true)}
                      className="btn-search-sm whitespace-nowrap flex-shrink-0"
                    >
                      검색
                    </button>
                  </div>
                )}

                <CompanySearch
                  open={modalOpen}
                  onClose={() => setModalOpen(false)}
                  onSelect={(company) =>
                    setForm({
                      ...form,
                      confirmer_company_name: company.name,
                      manualCompanyInput: false,
                    })
                  }
                />
              </div>

              {/* 실제 날짜들 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                <div className="space-y-1">
                  <label className="text-xs font-medium text-gray-600">
                    최초 계약일자
                  </label>
                  <input
                    type="date"
                    name="signed_date_actual"
                    value={form.signed_date_actual}
                    onChange={handleChange}
                    className="w-full border rounded-md px-2 py-1 text-sm"
                  />
                </div>

                <div className="space-y-1">
                  <label className="text-xs font-medium text-gray-600">
                    착수일
                  </label>
                  <input
                    type="date"
                    name="start_date_actual"
                    value={form.start_date_actual}
                    onChange={handleChange}
                    className="w-full border rounded-md px-2 py-1 text-sm"
                  />
                </div>

                <div className="space-y-1">
                  <label className="text-xs font-medium text-gray-600">
                    종료일
                  </label>
                  <input
                    type="date"
                    name="end_date_actual"
                    value={form.end_date_actual}
                    onChange={handleChange}
                    className="w-full border rounded-md px-2 py-1 text-sm"
                  />
                </div>
              </div>

              {/* 예정일들 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                <div className="space-y-1">
                  <label className="text-xs font-medium text-gray-600">
                    계약 예정일자
                  </label>
                  <input
                    type="date"
                    name="sign_date_expected"
                    value={form.sign_date_expected}
                    onChange={handleChange}
                    className="w-full border rounded-md px-2 py-1 text-sm"
                  />
                </div>

                <div className="space-y-1">
                  <label className="text-xs font-medium text-gray-600">
                    계약 종료 예정일
                  </label>
                  <input
                    type="date"
                    name="end_date_expected"
                    value={form.end_date_expected}
                    onChange={handleChange}
                    className="w-full border rounded-md px-2 py-1 text-sm"
                  />
                </div>
              </div>

              {/* 특이사항 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  특이사항
                </label>
                <textarea
                  name="memo"
                  value={form.memo}
                  onChange={handleChange}
                  className="w-full h-32 border rounded-md px-2 py-2 text-sm resize-none"
                />
              </div>
            </div>
          </div>

          {/* 파일 업로드 */}
          <div className="mb-4">
            <label className="block text-sm mb-1">첨부파일 (선택)</label>
              <MobileAttachmentBox ref={attachmentRef} />
          </div>
        </form>
        </div>
      </div>
    </div>
  );
};

export default Info_new;
